import { getPath } from '@/router/common'

const baseUrl = {
  title: '单价信息',
  path: 'accInfo'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'accInfo_Index',
    component: () => import(/* webpackChunkName: "accInfo_Index" */ '@/views/accInfo/index/index.vue'),
    meta: {
      title: '单价信息'
    }
  },
  {
    path: getPath('addOrEdit', baseUrl),
    name: 'accInfo_addOrEdit',
    component: () => import(/* webpackChunkName: "accInfo_addOrEdit" */ '@/views/accInfo/addOrEdit/index.vue'),
    meta: {
      title: '单价信息新增修改'
    }
  }
]
